import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group, Stack } from "@mantine/core";
import { Trans } from "react-i18next";
import AffiliateCodeCard from "./components/AffiliateCodeCard";
import AffiliateLinkCard from "./components/AffiliateLinkCard";
import AffiliationTable from "./components/AffiliationTable";
import ClientDashboardTitle from "./components/ClientDashboardTitle";
import CoinCard from "./components/CoinCard";
import Coins, { ECoinVariant } from "./components/Coins";
import NextUserRewardCard from "./components/NextUserRewardCard";
import ContainerCard from "./components/container/ContainerCard";
import ContainerText from "./components/container/ContainerText";

const Affiliation: React.FC = () => {
  const { t } = useAppTranslation("pages.clientDashboard");

  return (
    <Stack>
      <ClientDashboardTitle
        icon={<Coins variant={ECoinVariant.AFFILIATE} size={40} />}
        label={t("affiliation.title")}
        subHeader={t("affiliation.subHeader")}
      />

      <Group className="items-start lg:flex-col xl:flex-row">
        <Stack className="w-full justify-stretch lg:max-w-[80%] xl:max-w-[60%]">
          <Group className="xs:flex-col items-stretch justify-center sm:flex-row">
            <CoinCard
              containerProps={{
                classNames: {
                  root: "w-full xs:w-auto",
                  wrapper: "w-full xs:w-auto",
                },
              }}
            />

            <AffiliateLinkCard
              containerProps={{
                classNames: {
                  root: "min-w-[200px] xs:w-full flex-1",
                },
              }}
            />
          </Group>

          <Group className="items-stretch justify-center">
            <NextUserRewardCard
              containerProps={{
                classNames: {
                  root: "w-full sm:w-auto xl:flex-1",
                  wrapper: "w-full sm:w-auto",
                },
              }}
            />

            <AffiliateCodeCard
              containerProps={{ classNames: { root: "min-w-[200px] flex-1" } }}
            />
          </Group>

          <ContainerCard
            title={t("affiliation.howItWorks.title")}
            classNames={{ root: "w-full" }}
          >
            <ContainerText>{t("affiliation.howItWorks.step1")}</ContainerText>
            <ContainerText>
              <Trans i18nKey="pages.clientDashboard.affiliation.howItWorks.step2">
                2. Lorsqu’un ami achète un compte via ton lien, tu gagnes{" "}
                <span className="text-[#FFCD26]">+2 pièces</span> par euro
                dépensé par ton ami.
              </Trans>
            </ContainerText>
            <ContainerText>{t("affiliation.howItWorks.step3")}</ContainerText>
          </ContainerCard>
        </Stack>

        <AffiliationTable />
      </Group>
    </Stack>
  );
};

export default Affiliation;
